import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contract";

export function ShowLinesCommand(lines: number | number[]): Contract<void> {

    if (typeof lines === "number") {
        const linesArr = [];

        for (let i = 1; i <= lines; i++) {
            linesArr.push(i);
        }

        lines = linesArr;
    }

    for (const line of lines) {
        Components.lines.showLine(line, true);
    }

    return Contract.empty();
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/lines/show-lines-command.ts